import {
  useEffect,
  useState,
} from "react";

import {
  AnimatePresence,
  motion,
} from "framer-motion";

import {
  Link,
} from "react-router-dom";

import {
  getRoutePath,
} from "../../../site/config/routes";

/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  MOBILE STICKY CTA
  ============================================================

  Näkyy vain mobiilissa / tabletissa.

  - ilmestyy vasta ensimmäisen viewportin jälkeen
  - häviää Yhteys-osion tullessa näkyviin
  - FI / EN
  - ei peitä desktop-layoutia
  - ei kilpaile oikean reunan scroll-to-top-painikkeen kanssa
*/

export default function MobileStickyCta({
  language = "fi",
}) {
  const [
    visible,
    setVisible,
  ] = useState(false);

  useEffect(() => {
    let frame = null;

    const updateVisibility =
      () => {
        frame = null;

        /*
          Desktopilla komponentti piilotetaan CSS:llä,
          mutta vältetään turha näkyvyystilan käsittely.
        */

        if (
          window.innerWidth >=
          1024
        ) {
          setVisible(false);
          return;
        }

        const viewportHeight =
          window.innerHeight;

        const scrollTop =
          window.scrollY ||
          document.documentElement.scrollTop ||
          0;

        /*
          CTA tulee näkyviin vasta kun käyttäjä
          on lähtenyt kunnolla etusivua alaspäin.
        */

        const passedIntro =
          scrollTop >
          viewportHeight *
            0.85;

        /*
          Kun yhteysosio alkaa tulla ruutuun,
          sticky CTA väistyy pois.
        */

        const contact =
          document.getElementById(
            "home-contact"
          );

        let contactVisible =
          false;

        if (contact) {
          const rect =
            contact.getBoundingClientRect();

          contactVisible =
            rect.top <
              viewportHeight *
                0.9 &&
            rect.bottom >
              0;
        }

        setVisible(
          passedIntro &&
          !contactVisible
        );
      };

    const requestUpdate =
      () => {
        if (
          frame !== null
        ) {
          return;
        }

        frame =
          window.requestAnimationFrame(
            updateVisibility
          );
      };

    updateVisibility();

    window.addEventListener(
      "scroll",
      requestUpdate,
      {
        passive: true,
      }
    );

    window.addEventListener(
      "resize",
      requestUpdate
    );

    return () => {
      window.removeEventListener(
        "scroll",
        requestUpdate
      );

      window.removeEventListener(
        "resize",
        requestUpdate
      );

      if (
        frame !== null
      ) {
        window.cancelAnimationFrame(
          frame
        );
      }
    };
  }, []);

  const label =
    language === "en"
      ? "Book a session"
      : "Varaa kuvaus";

  return (
    <div
      className="
        pointer-events-none
        fixed
        inset-x-0
        bottom-5
        z-[110]
        flex
        justify-center
        px-5

        lg:hidden
      "
    >
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{
              opacity: 0,
              y: 18,
              scale: 0.98,
            }}
            animate={{
              opacity: 1,
              y: 0,
              scale: 1,
            }}
            exit={{
              opacity: 0,
              y: 12,
              scale: 0.985,
            }}
            transition={{
              duration: 0.35,
              ease: [
                0.22,
                1,
                0.36,
                1,
              ],
            }}
          >
            <Link
              to={getRoutePath(
                "contact",
                language
              )}
              className="
                group
                pointer-events-auto
                inline-flex
                min-h-12
                items-center
                justify-center
                gap-4
                rounded-full
                border
                border-text/10
                bg-text
                px-6
                py-3
                text-[9px]
                font-semibold
                uppercase
                tracking-[0.2em]
                text-canvas
                no-underline
                shadow-[0_8px_30px_rgba(0,0,0,0.12)]
                transition-transform
                duration-300

                active:scale-[0.98]

                sm:min-h-13
                sm:px-7
                sm:text-[10px]
              "
            >
              <span>
                {label}
              </span>

              <span
                className="
                  text-sm
                  font-normal
                  transition-transform
                  duration-300
                  group-hover:translate-x-1
                "
                aria-hidden="true"
              >
                →
              </span>
            </Link>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}